import { QueryClient } from "@tanstack/react-query";

// 상품 목록(상품 찾기·담은 상품 공용 키) 캐시 갱신.
// 화면에 없는 목록은 비운다 — invalidate만 하면 재진입 시 옛 카드가 먼저 그려지고
// 배지·담김 상태가 뒤늦게 바뀐다. 비우면 첫 진입처럼 스켈레톤을 거쳐 최신 상태로 한 번에 뜬다.
// 보고 있는 목록은 그 자리에서 다시 받는다(깜빡이지 않는다).
//
// type: "inactive" 필터 대신 predicate를 쓴다 — resetQueries는 필터를 refetch에도 그대로 펼쳐
// inactive 목록을 즉시 다시 받아 버린다. predicate면 refetch 대상(active)과 겹치지 않아 요청이 없다.
export const refreshPathPickProducts = (
  queryClient: QueryClient,
  companyId: number | undefined
) => {
  const queryKey = ["pathpick", "api-products", companyId];
  queryClient.resetQueries({
    queryKey,
    predicate: (query) => !query.isActive(),
  });
  queryClient.invalidateQueries({ queryKey });
};
